import { json, type LinksFunction } from '@remix-run/node';
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from '@remix-run/react';
import { withSentry } from '@sentry/remix';
import polarisStyles from '@shopify/polaris/build/esm/styles.css?url';
import tailwindStyles from './tailwind.css?url';

export const links: LinksFunction = () => [
    { rel: 'stylesheet', href: polarisStyles },
    { rel: 'stylesheet', href: tailwindStyles },
];

export async function loader() {
    let env = { SENTRY_DSN: process.env.SENTRY_DSN! };
    return json({ env });
}

export function ErrorBoundary() {
    return (
        <html>
            <head>
                <title>Error</title>
                <Meta />
                <Links />
            </head>
            <body>
                <h1>Something went wrong</h1>
                <Scripts />
            </body>
        </html>
    );
}

function App() {
    return (
        <html>
            <head title="Express POS">
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width,initial-scale=1" />
                <Meta />
                <Links />
            </head>
            <body>
                <Outlet />
                <ScrollRestoration />
                <Scripts />
            </body>
        </html>
    );
}

export default withSentry(App);
